import axios from 'axios';
import { applySessionRequestPolicy } from './requestPolicy';
import {
  instrumentPerformanceError,
  instrumentPerformanceRequest,
  instrumentPerformanceResponse,
} from './performanceTrace';
import { createInFlightDedupAdapter } from './requestDedup';

const httpClient = axios.create({
  withCredentials: true,
});

httpClient.defaults.adapter = createInFlightDedupAdapter(
  axios.getAdapter(httpClient.defaults.adapter),
);

httpClient.interceptors.request.use((config) =>
  instrumentPerformanceRequest(applySessionRequestPolicy(config))
);
httpClient.interceptors.response.use(
  instrumentPerformanceResponse,
  instrumentPerformanceError
);

export default httpClient;
